import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTitle } from '../../common/hooks';
import './EoNoAccessPage.scss';

const EoNoAccessPageImpl: React.FC = () => {

  useTitle('EO 14117 - Access Restricted');

  return (
    <main className='eo-no-access-page'>
      <h1>Access Restricted</h1>

      <p>
        Your access to this tool has been restricted in compliance with
        US Executive Order 14117: "Preventing Access to Americans' Bulk Sensitive
        Personal Data and United States Government-Related Data by Countries of Concern."
      </p>

      <p>
        If you believe this restriction has been applied in error or if you
        require access for legitimate business purposes, please {' '}
        <a
          href='mailto:potyasup@microsoft.com'
          rel='noopener noreferrer'
        >
          contact our support
        </a>.
      </p>

      <p>
        For the complete Executive Order, visit:{' '}
        <a
          href='https://www.federalregister.gov/documents/2024/03/01/2024-04573/preventing-access-to-americans-bulk-sensitive-personal-data-and-united-states-government-related'
          target='_blank'
          rel='noopener noreferrer'
          className='legal-link'
        >
          US Federal Register - EO 14117
        </a>
      </p>
    </main>
  );
}

export const EoNoAccessPage = observer(EoNoAccessPageImpl);
